export const loginError = 'Login failed, please check your domain/username/password and allow pop-ups';
